import {
  autocompletion,
  closeBrackets,
  closeBracketsKeymap,
  completionKeymap,
} from '@codemirror/autocomplete';
import { defaultKeymap, history, historyKeymap } from '@codemirror/commands';
import {
  bracketMatching,
  defaultHighlightStyle,
  foldGutter,
  foldKeymap,
  indentOnInput,
  syntaxHighlighting,
} from '@codemirror/language';
import { lintKeymap } from '@codemirror/lint';
import type { Extension } from '@codemirror/state';
import { EditorSelection, EditorState } from '@codemirror/state';
import {
  crosshairCursor,
  drawSelection,
  dropCursor,
  type EditorView,
  highlightSpecialChars,
  keymap,
  rectangularSelection,
} from '@codemirror/view';

function closeDoubleQuote(view: EditorView): boolean {
  const { head } = view.state.selection.main;
  const next = view.state.doc.sliceString(head, head + 1);
  if (next === '"') {
    view.dispatch({
      selection: EditorSelection.cursor(head + 1),
    });
    return true;
  }
  view.dispatch({
    changes: { from: head, to: head, insert: '""' },
    selection: EditorSelection.cursor(head + 1),
  });
  return true;
}

/**
 * Editor setup equivalent to codemirror basicSetup but without line numbers,
 * active line gutter, active line highlight, or @codemirror/search (for a minimal template editor).
 */
export const textChartEditorSetup: Extension[] = [
  highlightSpecialChars(),
  history(),
  foldGutter(),
  drawSelection(),
  dropCursor(),
  EditorState.allowMultipleSelections.of(true),
  indentOnInput(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  bracketMatching(),
  closeBrackets(),
  autocompletion(),
  rectangularSelection(),
  crosshairCursor(),
  keymap.of([
    { key: '"', run: closeDoubleQuote },
    ...closeBracketsKeymap,
    ...defaultKeymap,
    ...historyKeymap,
    ...foldKeymap,
    ...completionKeymap,
    ...lintKeymap,
  ]),
];
